package xyz.luan.bpc.operation

import xyz.luan.bpc.inverse
import xyz.luan.bpc.parser.ParsingContext

enum class MarkingOperation(
    val value: String,
) {
    DIAMOND("diamond") {
        override fun process(operation: StepOperation, value: Double): Double = inverse(value)
    },
    SLASH("slash") {
        override fun process(operation: StepOperation, value: Double): Double = value / 2
    },
    DOTS("dots") {
        override fun process(operation: StepOperation, value: Double): Double = value * 2
    },
    CROSS("cross") {
        override fun process(operation: StepOperation, value: Double): Double = operation.neutralValue
    },

    ;

    abstract fun process(operation: StepOperation, value: Double): Double

    companion object {
        fun parse(context: ParsingContext, value: String): MarkingOperation {
            return entries.find { it.value == value }
                ?: context.fail("Invalid marking operation value: $value")
        }
    }
}
